import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

import { uploadTimelineImage } from './helpers'

const useTimeLineComment = ({
  storeId,
  resourceId,
  setToastInfo,
  fetchTimeline,
  sendCommentService,
  uploadProductImageService,
}) => {
  const { t } = useTranslation()
  const [selectedTimelineImages, setSelectedTimelineImages] = useState([])
  const { fetchData: sendComment } = useFetch(sendCommentService, { doInitialRequest: false })
  const { data: users, loading } = useFetch(() => configurationServices.getUsers({ storeId: storeId }), {
    doInitialRequest: !!storeId,
  })

  const onSelectTimelineImages = async images => {
    await images.forEach(async imageFile => {
      const response = await uploadTimelineImage(imageFile, storeId, resourceId, uploadProductImageService)
      setSelectedTimelineImages(images => [...images, response])
    })
  }

  const onDeleteTimelineImage = imageId => {
    setSelectedTimelineImages(images => images.filter(image => image.id !== imageId))
  }

  const sendTimelineComment = (text, mentions) => {
    sendComment(
      {
        storeId: storeId,
        resourceId: resourceId,
        text,
        imageIds: selectedTimelineImages.map(image => image.id),
        mentions,
      },
      () => {
        setToastInfo({ show: true, message: t('Mensaje enviado'), type: 'success' })
        fetchTimeline()
        setSelectedTimelineImages([])
      },
      err => {
        setToastInfo({ show: true, message: err.errorMessage, type: 'error' })
      }
    )
  }

  return {
    onSelectTimelineImages,
    onDeleteTimelineImage,
    sendTimelineComment,
    loading,
    users,
    setSelectedTimelineImages,
    selectedTimelineImages,
  }
}

export default useTimeLineComment
